
<template>
    <div class="animated fadeIn c-settings-panel">
        <b-row  class="mb-2">
            <b-col>
                <b-button @click="gotoSettings" class="btn btn-light pull-left"><i class="fa fa-chevron-left mr-2"></i>{{Core.Definition.getDefinition('Paramètres')}}</b-button>
                <div style="clear: both"></div>
                <hr/>
            </b-col>
        </b-row>
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))

    export default {
        name: 'SettingsContainer',
        components: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
            gotoSettings() {
                this.$router.push(Core.Definition.getDefinition('/systeme/parametres'))
            }
        }
    }
</script>
